import { MutationTree } from 'vuex';
import { ProfessionalState, Professional } from './professional-types';

export const mutations: MutationTree<ProfessionalState> = {
  setProfessionalInState(state, payload: Professional) {
    state.error = false;
    state.professional = payload;
  },
  profileError(state) {
    state.error = true;
    state.professional = undefined;
  },
};
